const formatNumberWithCommas = (number, options) => {
  if (number === null || typeof number === "undefined" || number === "") {
    return options?.asCurrency ? "0.00" : "0";
  }

  const num = Number(number);

  if (isNaN(num)) {
    return options?.asCurrency ? "0.00" : "0";
  }

  const hasDecimals = num % 1 !== 0;
  const forceDecimals = options?.asCurrency || hasDecimals;

  return num.toLocaleString("en-US", {
    minimumFractionDigits: forceDecimals ? 2 : 0,
    maximumFractionDigits: 2,
  });
};

export default formatNumberWithCommas;
